import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../routes/routes";
import AuthClient from "../../api/AuthClient";
import { CitiesInfoContext } from "../../AllCitiesContext";

export default function PromoterBannerCityLink() {
  const [cityName, setCityName] = useState("");
  const { selectedCity } = useContext(CitiesInfoContext);

  useEffect(() => {
    const raw = localStorage.getItem("cityInfo");
    if (raw) {
      try {
        const info = JSON.parse(raw) as { cityName?: string };
        if (info.cityName) {
          setCityName(info.cityName);
          return;
        }
      } catch {
        // ignore malformed localStorage and fallback
      }
    }

    const auth = new AuthClient().getAuthenticationResponse();
    if (auth?.cityName) {
      setCityName(auth.cityName);
    }
  }, [selectedCity]);

  return (
    <Link
      className="promoterBannerCityLink"
      to={routes.CitySelector}
      title="Change city"
    >
      {cityName || "City"}
    </Link>
  );
}
